module.exports = __webpack_public_path__ + "img/a2.456f7db3.jpg";